import { Page as Component } from "~/components/specifics/settings/company_store_mails/Page";

export function Page() {
	return <Component />;
}
